/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 出荷数量8
 * @export
 * @interface Col8
 */
export interface Col8 {
}

/**
 * Check if a given object implements the Col8 interface.
 */
export function instanceOfCol8(value: object): value is Col8 {
    return true;
}

export function Col8FromJSON(json: any): Col8 {
    return Col8FromJSONTyped(json, false);
}

export function Col8FromJSONTyped(json: any, ignoreDiscriminator: boolean): Col8 {
    return json;
}

export function Col8ToJSON(json: any): Col8 {
    return Col8ToJSONTyped(json, false);
}

export function Col8ToJSONTyped(value?: Col8 | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

